import { makeStyles } from '@material-ui/core';
export default makeStyles(function (theme) {
  var _theme$palette$red$, _theme$palette;
  return {
    root: {
      color: (_theme$palette$red$ = theme === null || theme === void 0 ? void 0 : (_theme$palette = theme.palette) === null || _theme$palette === void 0 ? void 0 : _theme$palette.red[300]) !== null && _theme$palette$red$ !== void 0 ? _theme$palette$red$ : 'red',
      marginRight: 4
    }
  };
});